export const CONTEXT_KEY = 'slotsContextV1';
//# sourceMappingURL=constants.js.map